export const syncCalendar = {
  title: "Sincronize seus calendários",
  description:
    "Sua acomodação está anunciada em vários sites? Sincronizar seus calendários ajuda a ver suas reservas e disponibilidade em todos os canais de uma só vez. Você pode importar e exportar calendários no formato iCal e manter sua lista de check-ins agendados sempre atualizada.",
  accommodation: "Acomodação",
  sync: "Sincronizar",
  addCalendar: "Adicionar novo calendário",
  confirmSync: {
    message: "Deseja atualizar os calendários?",
  },
  syncSuccess: {
    message: "Calendários sincronizados com sucesso",
    title: "Sincronização concluída",
  },
  calendarName: "Nome do calendário",
  modal: {
    header: "Adicionar calendário",
    nameLabel: "Insira o nome do calendário",
    linkLabel: "Copie e cole o link do seu calendário aqui",
    linkPlaceholder: "Link iCal",
    cancel: "Cancelar",
    save: "Salvar e sincronizar",
  },
  saveSuccess: {
    message: "Sucesso",
    title: "Calendário salvo com sucesso",
  },
  errors: {
    validationTitle: "Falha na validação",
    saveErrorTitle: "Erro ao salvar o calendário",
    unexpected: "Ocorreu um erro inesperado.",
  },
  list: {
    updated: "Atualizado",
    status: "Status",
    synced: "Sincronizado",
    delete: "Excluir",
    empty: "Nenhum calendário sincronizado",
  },
  deleteConfirm: {
    title: "Deseja excluir o calendário?",
    content:
      'Excluir o calendário também excluirá as reservas sincronizadas no menu "Check-ins agendados (reservas)"',
  },
  deleteSuccess: {
    message: "Calendário excluído com sucesso",
    title: "Excluído",
  },
  deleteError: {
    message: "Erro ao excluir o calendário",
    title: "Erro",
  },
};
